export default __webpack_public_path__ + "static/media/arrow-right.e2b4839b.svg";